module.exports={
    "processing" : "Paid",
    "fraud": "Suspected Fraud",
    "pending_payment": "Pending Payment",
    "payment_review": "Payment Review",
    "pending": "Pending",
    "holded": "On Hold",
    "complete": "Complete",
    "closed": "Closed",
    "canceled": "Canceled",
    "paypal_canceled_reversal": "PayPal Canceled Reversal",
    "pending_paypal": "Pending PayPal",
    "paypal_reversed": "PayPal Reversed"
}